import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    /* Background */
    st1: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor,
        };
    },

    /* font color */
    st2: (props) => {
        const {
            fontColor,
        } = props;

        return {
            fill: fontColor,
        };
    },

    st4: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st5: {
        fill: '#FFFFFF',
    },

}));
